import { createSelector } from 'reselect';

const metalStreamSelector = (state) => state.metalStream;

export const selectMetalStreamSettings = createSelector(
  metalStreamSelector,
  (state) => state.metalStreamSettings,
);

export const selectMetalStreamProducts = createSelector(
  metalStreamSelector,
  (state) => state.Products,
);

export const selectMetalStreamGoldProducts = createSelector(
  metalStreamSelector,
  (state) => state.GoldProducts,
);

export const selectMetalStreamSilverProducts = createSelector(
  metalStreamSelector,
  (state) => state.SilverProducts,
);

export const selectMetalStreamSelectedGoldProduct = createSelector(
  metalStreamSelector,
  (state) => state.Settings.SelectedGoldProduct,
);

export const selectMetalStreamSelectedSilverProduct = createSelector(
  metalStreamSelector,
  (state) => state.Settings.SelectedSilverProduct,
);

export const selectMetalStreamAllocationSilver = createSelector(
  metalStreamSelector,
  (state) => state.Settings.SilverPercentage,
);

export const selectMetalStreamAllocationGold = createSelector(
  metalStreamSelector,
  (state) => state.Settings.GoldPercentage,
);

export const selectMetalStreamInvestmentAmount = createSelector(
  metalStreamSelector,
  (state) => state.Settings.Amount,
);
